import React, { useEffect, useState } from "react";
import { FiSmile, FiFrown } from "react-icons/fi";
import { CgSmileNone } from "react-icons/cg";

import Typography from "../../../../../Typography";

import { ReactComponent as ArrowDownIcon } from "../../../../../../build/images/nps-dashboard-icons/arrow-down.svg";

import "./satisfaction-select.css";

export default function SatisfactionSelect({ disabled = true, defaultOption }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(defaultOption);

    const options = [
        { value: 'satisfied', label: 'Cliente satisfeito', icon: <FiSmile color="green" /> },
        { value: 'unsatisfied', label: 'Cliente insatisfeito', icon: <FiFrown color="#c90000" /> },
        { value: 'indiferent', label: 'Cliente indiferente', icon: <CgSmileNone color="#F2BD00" /> },
    ];

    const toggleSelect = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };

    const handleOptionClick = (value) => {
        setSelectedOption(value);
        setIsOpen(false);
    };

    const selectedOptionData = options.find((option) => option.value === selectedOption) || {};
    const { icon: selectedOptionIcon, label: selectedOptionLabel } = selectedOptionData;

    useEffect(() => {
        setSelectedOption(defaultOption);
    }, [defaultOption]);

    return (
        <div className="custom-select-container" onClick={toggleSelect}>
            <div className="selected-option">
                {selectedOptionIcon}
                <span>
                    <Typography.H4 weight="400" color={selectedOption === 'satisfied' ? 'green' : selectedOption === "unsatisfied" ? 'red-2':'yellow'}>
                        {selectedOptionLabel}
                    </Typography.H4>
                </span>
            </div>

            <ArrowDownIcon className={`arrow-icon ${isOpen ? "active" : ""}`} />

            {isOpen && (
                <div className="custom-options-container">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className="custom-option"
                            onClick={() => handleOptionClick(option.value)}
                        >
                            {option.icon}
                            <span style={{ marginLeft: '8px' }}>
                                <Typography.H4>
                                    {option.label}
                                </Typography.H4>
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}